export * from './tiptap-editor-wrapper.component';
